import { render, staticRenderFns } from "./DocumentItem.vue?vue&type=template&id=32dd9031&scoped=true"
import script from "./DocumentItem.vue?vue&type=script&lang=js"
export * from "./DocumentItem.vue?vue&type=script&lang=js"
import style0 from "./DocumentItem.vue?vue&type=style&index=0&id=32dd9031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd9031",
  null
  
)

export default component.exports